import { useId } from 'react';

import React from 'react'
import { ITask } from '../../../data_models/task'
import { Chip } from '../Chip'
import { FilledButton } from '../Button'
import useConfig from '../../../hooks/useConfig';
import { TaskEnumTextMapper, UserEnumTextMapper } from '../../../data_models/enumToTextMapper';
import { FreelancerRole } from '../../../data_models/freelancer';
import { dateToShortReadable } from '../../../utils/dateUtils';
import useMyTasks from '../../../hooks/useMyTasks';
import useGlobalLoading from '../../../hooks/useGlobalLoading';

interface BriefTaskComponentProps {
    task: ITask
}

const BriefTaskComponent: React.FC<BriefTaskComponentProps> = ({ task }) => {

    const { config } = useConfig();
    const { applications, applyForTask } = useMyTasks();
    const { setLoading } = useGlobalLoading();



    return (
        <div className="border bg-white border-neutral-500 shadow-lg rounded-lg p-4">
            {/* Title, Role & Action Button*/}
            <div className="flex justify-between items-center">
                <div>
                    <p className="body2 font-bold">{task.title}</p>
                    <p className="text-neutral-900 caption1">{UserEnumTextMapper.freelancerRole(task.requiredRole || FreelancerRole.OTHER)}</p>
                </div>
                {applications[task._id!]
                    ? <p className='body3 text-neutral-700'>Application sent</p>
                    : <FilledButton onClick={async () => {
                        setLoading(true);
                        await applyForTask(task.projectId!, task._id!)
                        setLoading(false);
                    }}>Apply now</FilledButton>
                }
            </div>

            {/* Payment & Role */}
            <div className="mt-4 flex flex-row justify-between">
                <div className="flex flex-row space-x-2 items-center">
                    <div className={`rounded-full w-1 h-1 bg-neutral-900 `} />
                    <p className="caption1 text-neutral-700 font-bold">{task.estimatedCredits} Credits</p>
                    {config?.rateCreditsToUsd.freelancer && <p className="caption1 text-neutral-700">(${task.estimatedCredits! * (config?.rateCreditsToUsd.freelancer || 0)} USD)</p>}
                </div>
                {/* <div className="flex flex-row space-x-2 items-center">
                                        <div className={`rounded-full w-1 h-1 bg-neutral-900 `} />
                                        <p className="text-neutral-900">{task.requiredRole}</p>
                                    </div> */}
            </div>

            {/* Required Skills */}
            {(task.requiredSkills?.length || 0) > 0 &&
                < div className="mt-4 flex flex-wrap gap-2 items-center">
                    <p className="caption1">Required Skills:</p>
                    {task.requiredSkills?.map((skill) => (
                        <div key={skill}><Chip>{skill}</Chip></div>
                    ))}
                </div>}


            {/* Required Tools */}
            {(task.requiredTools?.length || 0) > 0 &&
                < div className="mt-4 flex flex-wrap gap-2 items-center">
                    <p className="caption1">Required Tools:</p>
                    {task.requiredTools?.map((tool) => (
                        <div key={tool}><Chip theme="secondary">{tool}</Chip></div>
                    ))}
                </div>}

            {/* Description */}
            <div className="mt-4 flex flex-col items-start">
                <p className="caption1 text-left">{task.briefDescription}</p>
            </div>

            {/* Start & Due Date */}
            {/* < div className="mt-4 flex flex-wrap gap-2 items-center">
                <p className="caption1 font-bold">Start:</p>
                <p>{task.startDate ? dateToShortReadable(task.startDate) : "ASAP"}</p>
                <p className="caption1 font-bold">Due:</p>
                <p>{task.dueDate ? dateToShortReadable(task.dueDate) : "ASAP"}</p>
            </div> */}
        </div>
    )
}

export default BriefTaskComponent